import { delay } from '../../../Functions/DelayFn'
import ValidatedTextfield from '../../../Components/ValidatedTextfield'
import { useGlobalContext } from '../../../Contexts/GlobalTriggers'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import {
  useValidateServerSampleID,
  validPatternSampleID,
} from '../../../APIs/Hooks/SampleHooks'

function SampleIDInput({
  setValue,
  setValidID,
  valid,
  value,
  disabled,
}: {
  value: string
  valid: boolean
  setValue: any
  setValidID: any
  disabled: boolean
}) {
  const { setMessage } = useMessagePopupContext()
  const { playScanSound } = useGlobalContext()
  const { mutate: serverValidateID } = useValidateServerSampleID(
    setValue,
    setValidID,
  )

  return (
    <ValidatedTextfield
      disabled={disabled}
      required
      value={value}
      label="Sample ID"
      fullwidth
      onChange={(e: any) => setValue(e)}
      inputProps={{ valid: String(valid) }}
      onBlur={async (e: any) => {
        await delay(500)
        const sample_id = e.target.value
        playScanSound(true)
        if (!validPatternSampleID(sample_id)) {
          setValue('')
          setMessage({
            subject: 'Wrong Format',
            message: 'ID does not match XX00000 pattern',
            severity: 'warning',
          })
        } else {
          serverValidateID(e.target.value)
        }
      }}
    />
  )
}

export default SampleIDInput
